<template>
  <div :class="tableClass" :style="{ maxHeight: maxHeight }">
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <table>
      <thead>
        <tr>
          <th
            v-for="(header, index) in headers"
            :key="`header${index}`"
            :style="header.style"
            ref="tableHeader"
          >
            <!--          <span class="change-item-table-head"></span>-->
            <slot :name="`header.${header.value}`" :header="header">
              <span
                v-if="header.sortable"
                @click="changeSortHandler(header.value)"
                :class="[
                  'cursor-pointer',
                  'table-wth-children-sortable-th',
                  { active: header.value === options.sortBy },
                ]"
                >{{ header.text }}
                <v-icon small class="table-wth-children-sortable-icon">{{
                  options.sortDirection ? "mdi-arrow-down" : "mdi-arrow-up"
                }}</v-icon></span
              >
              <span v-else>{{ header.text }}</span>
            </slot>
            <div
              @mousedown="startResize($event, index)"
              class="table-with-children-head-grip"
            ></div>
          </th>
        </tr>
      </thead>
      <tbody v-for="(item, itemIndex) in items" :key="`bodyItem${itemIndex}`">
        <tr
          :class="[
            'table-wth-children-row table-wth-children-row-parent',
            item.parentClassName,
          ]"
        >
          <td
            :key="`item-${itemIndex}-${header.value}`"
            v-for="header in headers"
          >
            <div class="d-flex align-center">
              <slot
                :index="itemIndex"
                :name="`item.${header.value}`"
                :header="header"
                :item="item"
              >
                {{ item[header.value] }}
              </slot>
              <div class="expand-btn-wrap" v-if="header.value === handlerValue">
                <slot
                  name="expandBtn"
                  :item="item"
                  :header="header"
                  :handlerValue="handlerValue"
                  :openHandler="showChildHandler"
                >
                </slot>
              </div>
            </div>
          </td>
        </tr>
        <tr
          :class="[
            'table-wth-children-row-item',
            item.childClassName,
            child.className,
          ]"
          v-if="(item[childKey] && item.show) || alwaysOpen"
          v-for="(child, index) in item[childKey]"
          :key="`child-${item.id}-${index}`"
        >
          <td
            :key="`cell-${itemIndex}-${index}${header.value}`"
            v-for="header in headers"
          >
            <slot
              :index="index + 1"
              :name="`child.${header.value}`"
              :header="header"
              :item="item"
              :child="child"
            >
              {{ child[header.value] }}
            </slot>
          </td>
        </tr>
        <tr v-if="item[childKey] && item.show && item[childKey].length === 0">
          <td :colspan="headers.length" class="text-center">
            {{ $t("noDataAvailable") }}
          </td>
        </tr>
      </tbody>
      <tbody v-if="items.length === 0">
        <tr>
          <td :colspan="headers.length" class="text-center">
            {{ $t("noDataAvailable") }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
let clickedSameHeader = false;

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    fixTableColspan: {
      default: 10 * 10,
    },
    open: {
      type: Array,
      default: () => [],
    },
    itemKey: {
      type: String,
      default: "id",
    },
    options: {
      type: Object,
      default: () => {
        return {
          sortBy: null,
          sortDirection: false,
        };
      },
    },
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
    fixedHeader: {
      type: Boolean,
      default: false,
    },
    childKey: {
      type: String,
      default: "children",
    },
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    height: {
      type: Number,
    },
    openPromise: {},
    handlerValue: {
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    startResize(e, index) {
      const currentHeader = this.$refs.tableHeader[index];
      const startOffset = currentHeader.offsetWidth - e.pageX;
      currentHeader.parentElement.style.cursor = "col-resize";
      function mouseMove(e) {
        currentHeader.style.minWidth = startOffset + e.pageX + "px";
      }
      const mouseUp = (e) => {
        document.removeEventListener("mousemove", mouseMove);
        currentHeader.parentElement.style.cursor = "initial";
        document.removeEventListener("mouseup", mouseUp);
        this.$emit("table-header-resized", {
          index,
          header: this.headers[index],
          key: this.headers[index].value,
          width: startOffset + e.pageX + "px",
        });
      };
      document.addEventListener("mousemove", mouseMove);
      document.addEventListener("mouseup", mouseUp);
    },
    async showChildHandler(parent, promise) {
      if (!parent.show && promise) {
        parent.loading = true;
        try {
          await promise(parent);
          parent.show = !parent.show;
          if (parent[this.itemKey]) {
            this.open.push(parent[this.itemKey]);
          }
        } catch (e) {
          console.error(e);
          this.$emit("onException", e);
        } finally {
          parent.loading = false;
        }
      } else {
        parent.show = !parent.show;
        const open = this.open.filter((item) => {
          return parent[this.itemKey] !== item;
        });
        this.$emit("update:open", open);
      }
    },
    changeSortHandler(value) {
      if (this.options.sortBy === value) {
        if (!clickedSameHeader) {
          this.options.sortDirection = !this.options.sortDirection;
        } else {
          this.options.sortBy = null;
        }
        clickedSameHeader = true;
      } else {
        this.options.sortBy = value;
        clickedSameHeader = false;
      }

      this.$emit("update:sort", value);
    },
  },
  computed: {
    maxHeight() {
      const {
        breakpoint: { height },
      } = this.$vuetify;
      return this.height
        ? `${this.height}px`
        : this.fixedHeader
        ? `${height - 270}px`
        : "auto";
    },
    tableClass() {
      return [
        "table-wth-children",
        "table_cover",
        {
          "fixed-header": this.fixedHeader,
        },
      ];
    },
  },
};
</script>
